import { Button, Box, Slide, Typography } from '@mui/material';
import { useCallback, useEffect } from 'react';

import { blueGradientRoundButton } from '../../../assets/styles/blueGradientButton.style';
import {
  secondarySentence,
} from '../../../assets/styles/text.style';
import ModalProps from '../../../interfaces/ModalProps';


interface AlertWithTriggerProps extends ModalProps {
  open: boolean;
  handleClose: () => void;
  alertText: string;
  submitError: () => void;
}

const style = {
  display: 'flex',
  alignItems: 'flex-start', // Center vertically
  justifyContent: 'center', // Center horizontally
  flexDirection: 'column',
  borderRadius: '6px',
  position: 'fixed',
  top: '20px',
  left: 'calc(100% - 290px)',
  transform: 'translate(-100%, 5%)',
  width: 270,
  bgcolor: 'background.paper',
  boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', // Updated box-shadow
  p: 3,
  zIndex: 9999,
};

const ErrorToastComponent = ({ open, handleClose, alertText, submitError }: AlertWithTriggerProps) => {

  const handleModalCLoseHandler = useCallback(async () => {
    await new Promise(resolve => setTimeout(resolve, 5000));
    handleClose();
  }, [handleClose]);

  useEffect(() => {
    if (open)
      handleModalCLoseHandler();
  }, [open, handleModalCLoseHandler]);

  const submitTickethandler = () => {
    submitError();
  };
  return (
    <Slide direction='left' in={open}>
      <Box sx={style}>
        <Typography
          id='transition-modal-description'
          sx={{
            ...secondarySentence,
            color: 'black',
            textAlign: 'left',
          }}
        >
          {alertText}
        </Typography>

        {/* Done Button */}
        <Button
          fullWidth
          sx={{
            ...blueGradientRoundButton,
            color: 'black',
            margin: '8px 0 0 0',
            width: '120px',
            textTransform: 'none',
          }}
          onClick={submitTickethandler}
        >
          Submit ticket
        </Button>
      </Box>
    </Slide>
  );
};

export default ErrorToastComponent;
